import { SourceBaseOriginReport } from '@mri/app/modules';
import { PanelConfig } from '../types';

export const defaultAdminPanels: Array<PanelConfig> = [
  {
    title: 'General',
    statistics: [
      {
        title: 'Estados de conexión',
        containerClass: 'col-md-6',
        chartConfig: {
          sourceBases: [
            {
              originName: SourceBaseOriginReport.MOBILE_CURRENT,
              dimensions: [
                { key: 'statusReport' }
              ],
              metrics: [
                { key: 'total' }
              ],
              filters: {
                hasMobile: 'true'
              },
              metricValue: 'total',
            }
          ],
          type: 'circle',
          specialValues: {},
          seriesConfig: {
            key: 'connection',
            label: '$dimension0',
            dataType: 'string',
            colorResults: {
              'Conectado': '#5470C6',
              'Desconectado': '#FAC858',
            }
          },
        }
      },
      {
        title: 'Estados del motor',
        containerClass: 'col-md-6',
        chartConfig: {
          sourceBases: [
            {
              originName: SourceBaseOriginReport.MOBILE_CURRENT,
              dimensions: [
                { key: 'ignition' }
              ],
              metrics: [
                { key: 'total' }
              ],
              filters: {
                hasMobile: 'true'
              },
              metricValue: 'total',
            }
          ],
          type: 'circle',
          specialValues: {},
          seriesConfig: {
            key: 'engine',
            label: '$dimension0',
            dataType: 'string',
            colorResults: {
              'Encendido': '#91CC75',
              'Apagado': '#EE6666',
              'No definido': '#aaaaaa'
            }
          }
        }
      },
      {
        title: 'Velocidades máximas hoy',
        containerClass: 'col-md-6',
        chartConfig: {
          sourceBases: [
            {
              originName: SourceBaseOriginReport.POSITION,
              dimensions: [
                { key: 'mobileName' }
              ],
              metrics: [
                { key: 'maxSpeed' }
              ],
              filters: {
                startDeviceTime: '$startToday',
                endDeviceTime: '$endToday',
                hasMobile: true
              },
              metricValue: 'maxSpeed',
              sort: { maxSpeed: 'desc' },
              limit: 10,
            }
          ],
          type: 'bar',
          specialValues: {},
          seriesConfig: {
            key: 'mobileName',
            label: '$dimension0',
            dataType: 'string'
          },
          categoryConfig: {
            key: 'speedMax',
            label: 'Velocidad maxima',
          },
          valueConfig: {
            unitKey: '$speedUnitSystem'
          }
        }
      },
      {
        title: 'Horas de actividad hoy',
        containerClass: 'col-md-6',
        chartConfig: {
          sourceBases: [
            {
              originName: SourceBaseOriginReport.POSITION,
              dimensions: [
                { key: 'mobileName' },
              ],
              metrics: [
                { key: 'workTimeHours' }
              ],
              filters: {
                startDeviceTime: '$startToday',
                endDeviceTime: '$endToday',
                prevStartDeviceTime: '$startToday',
                prevEndDeviceTime: '$endToday',
                hasMobile: true
              },
              metricValue: 'workTimeHours',
              sort: { workTimeHours: 'desc' },
              limit: 10,
            }
          ],
          type: 'bar',
          specialValues: {},
          seriesConfig: {
            key: 'mobileName',
            label: '$dimension0',
            dataType: 'string'
          },
          categoryConfig: {
            key: 'workTimeHours',
            label: 'Horas de trabajo',
          },
          valueConfig: {
            unitKey: ''
          }
        }
      },
      {
        title: 'Kilometraje de vehículos hoy',
        containerClass: 'col-md-6',
        chartConfig: {
          sourceBases: [
            {
              originName: SourceBaseOriginReport.POSITION,
              dimensions: [
                { key: 'mobileName' },
              ],
              metrics: [
                { key: 'distance' }
              ],
              filters: {
                startDeviceTime: '$startToday',
                endDeviceTime: '$endToday',
                hasMobile: true
              },
              metricValue: 'distance',
              sort: { distance: 'desc' },
              limit: 10,
            }
          ],
          type: 'bar',
          specialValues: {},
          seriesConfig: {
            key: 'mobileName',
            label: '$dimension0',
            dataType: 'string'
          },
          categoryConfig: {
            key: 'distance',
            label: 'Odometro',
          },
          valueConfig: {
            unitKey: '$distanceUnitSystem'
          }
        }
      },
      {
        title: 'Cantidad de alarmas hoy',
        containerClass: 'col-md-6',
        chartConfig: {
          sourceBases: [
            {
              originName: SourceBaseOriginReport.ALARM_EVENT,
              dimensions: [
                { key: 'mobileName' },
              ],
              metrics: [
                { key: 'total' }
              ],
              filters: {
                startDeviceTime: '$startToday',
                endDeviceTime: '$endToday',
              },
              metricValue: 'total',
              sort: { total: 'desc' },
              limit: 10,
            }
          ],
          type: 'bar',
          specialValues: {},
          seriesConfig: {
            key: 'mobileName',
            label: '$dimension0',
            dataType: 'string'
          },
          categoryConfig: {
            key: 'total',
            label: 'Alarmas',
          }
        }
      }

      /*


      {
        title: 'Kilometraje de vehículos hoy',
        source: {
          source: PanelSourceName.CONSOLIDATE,
          filterConfig: {
            day: '$shortDayToday',
          },
        },
        containerClass: 'col-md-6 col-sm-6',
        type: 'bar',
        dimension: {
          mobileName: ''
        },
        metric: {
          avgOdometer: ''
        }

      },
      {
        title: 'Horas de actividad hoy',
        source: {
          source: PanelSourceName.CONSOLIDATE,
          filterConfig: {
            day: '$shortDayToday'
          }
        },
        containerClass: 'col-md-6 col-sm-6',
        type: 'bar',
        dimension: {
          mobileName: ''
        },
        metric: {
          avgHourmeter: ''
        }
      },
      {
        title: 'Cantidad de alarmas por día',
        source: {
          source: PanelSourceName.ALARM_EVENT,
          filterConfig: {
            day: '$shortDayToday'
          }
        },
        containerClass: 'col-md-6 col-sm-6',
        type: 'bar',
        dimension: {
          mobileName: ''
        },
        metric: {
          total: ''
        },
      }

       */
    ]
  }
];
